<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div class="register-content-wrapper">
    @if (!hideHeader) {
      <div class="register-header">
        <div style="height: 100%">
          <div>
            <span class="list-name">{{ pluralNameOverride ? pluralNameOverride : pluralName }}</span>
            @if (totalCount !== null) {
              <mat-chip class="list-count">{{ totalCount | number }}</mat-chip>
            }
          </div>
        </div>
        @if (showCreate) {
          <button
            class="create-button"
            type="button"
            mat-stroked-button
            color="primary"
            (click)="onCreate()"
            title="Create {{ name }}"
            #createButton
            >
            <span>Add {{ name }}</span>
          </button>
        }
        <ng-content class="create-button" select="ndt-register-create-options"></ng-content>
      </div>
    }
    <div class="list-options-bar">
      @if (hasSearchInput) {
        <mat-form-field>
          <mat-label>Find</mat-label>
          <input
            type="text"
            matInput
            [ngModel]="searchText"
            (ngModelChange)="onSearchTextChange($event)"
            name="search-input"
            autocomplete="off"
            />
            <mat-icon matSuffix class="list-search-icon">search</mat-icon>
          </mat-form-field>
        }
        <ng-content select="ndt-register-quick-filter"></ng-content>
        <span class="list-options-bar-spacer"> </span>
        @if (moreActionsMenu) {
          <button
            type="button"
            aria-label="More Actions"
            matTooltip="More Actions"
            mat-icon-button
            class="more-actions"
            [matMenuTriggerFor]="moreActionsMenu"
            >
            <mat-icon> more_vert </mat-icon>
          </button>
        }
      </div>
      <div class="ndt-table-wrapper" cdkScrollable>
        <ng-content></ng-content>
        <lcs-table-footer
          [callState]="callState"
          [pagingCallState]="pagingCallState"
          [itemCount]="totalCount"
          [hasNextPage]="hasNextPage"
          (loadMore)="onLoadMore()"
          >
          No {{ pluralNameOverride ?? pluralName | lowercase }} found.
        </lcs-table-footer>
      </div>
    </div>
  </lcs-loading-overlay>
